import React from 'react';
import { LEGAL_LAST_UPDATED } from '../../support/legal';

function LegalPageLayout({ title, children }) {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <header className="mb-8">
        <h1 className="text-3xl font-bold text-content-primary mb-2">{title}</h1>
        <p className="text-sm text-content-muted">Última atualização: {LEGAL_LAST_UPDATED}</p>
      </header>

      <div className="surface-card p-8 text-content-secondary text-sm leading-relaxed space-y-6">
        {children}
      </div>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section className="space-y-3">
      <h2 className="text-base font-semibold text-content-primary">{title}</h2>
      {children}
    </section>
  );
}

export default LegalPageLayout;
